"use strict";

exports.__esModule = true;
exports.processStyle = processStyle;
exports.processParams = processParams;

var _styleUnit = require("style-unit");

var _universalEnv = require("universal-env");

if (_universalEnv.isWeb && typeof document !== 'undefined') {
  // Temporary compatibility with setRpx
  (0, _styleUnit.setRpx)(document.documentElement.clientWidth / 750);
}

function processStyle(styles) {
  for (var prop in styles) {
    styles[prop] = (0, _styleUnit.convertUnit)(styles[prop], prop);
  }

  return styles;
}

function processParams(options, callback) {
  if (typeof options == 'function' || options == null) {
    callback = options;
    options = {
      timingFunction: 'ease',
      duration: 0,
      delay: 0
    };
  }

  return [options, callback];
}